<template>
  <section class="s-clients">
    <h2 v-html="data.h2"></h2>
    <div class="clients-container">
      <img src="/img/melinda.png" alt="Melinda" />
      <img src="/img/zuegg.png" alt="Zuegg" />
      <img src="/img/skipper.png" alt="Skipper" />
      <img src="/img/consorzio-del-formaggio-parmigiano Reggiano.png" alt="Consorzio del Formaggio Parmigiano Reggiano" />
      <img src="/img/eurospin.png" alt="Eurospin" />
      <img src="/img/alviero-martini.png" alt="Alviero Martini" />
      <img src="/img/american-pistachios.png" alt="American Pistachios" />
      <img src="/img/livigno.png" alt="Livigno" />
      <img src="/img/audika.png" alt="Audika" />
      <img src="/img/biogen.png" alt="Biogen" />
      <img src="/img/bosch-rexroth.png" alt="Bosch Rexroth" />
      <img src="/img/colussi.png" alt="Colussi" />
      <img src="/img/cantine-dolianova.png" alt="Cantine Dolianova" />
      <img src="/img/gruppo-mutuo-online.png" alt="Gruppo Mutuo Online" />
      <img src="/img/segugio.png" alt="Segugio.it" />
      <img src="/img/trovaprezzi.png" alt="Trovaprezzi.it" />
      <img src="/img/energit.png" alt="Energit" />
      <img src="/img/forma-carni.png" alt="Forma Carmi" />
      <img src="/img/formaggi-della-svizzera.png" alt="Formaggi dall Svizzera" />
      <img src="/img/franco-cosimo-panini.png" alt="Franco Cosimo Panini" />
      <img src="/img/yoox.png" alt="Yoox" />
      <!-- <img src="/img/consorzio-costa-smeralda.png" alt="Consorzio Costa Smeralda" /> -->
      <img src="/img/gruppo-sodalis.png" alt="Gruppo Sodalis" />
      <img src="/img/helvetia.png" alt="Helvetia" />
      <img src="/img/imac.png" alt="Imac" />
      <img src="/img/igi&co.png" alt="Igi & Co" />
      <img src="/img/primigi.png" alt="Primigi" />
      <img src="/img/agnesi.png" alt="Agnesi" />
      <img src="/img/colussi.png" alt="Colussi" />
      <img src="/img/misura.png" alt="Misura" />
      <img src="/img/marconi-express.png" alt="Marconi Express" />
      <img src="/img/cusumano.png" alt="Cusumano" />
      <img src="/img/la-linea-verde.png" alt="La Linea Verde" />
      <img src="/img/dimmidisi.png" alt="Dimmi di Si" />
      <img src="/img/mister-magic.png" alt="Mister Magic" />
      <img src="/img/podovis.png" alt="Podovis" />
      <img src="/img/inalpi.png" alt="Inalpi" />
      <img src="/img/dr-beckmann.png" alt="Dr. Beckmann" />
      <img src="/img/nieddittas.png" alt="Dieddittas Sardegna" />
      <img src="/img/organo-consulenti-finanziari.png" alt="Organo Consulenti Finanziari" />
      <img src="/img/pedon.png" alt="Pedon" />
      <img src="/img/perkin-elmer.png" alt="Perkin Elmer" />
      <img src="/img/moneyfarm.png" alt="Moneyfarm" />
      <img src="/img/sostec.png" alt="Sostec" />
      <img src="/img/formaggi-della-svizzera.png" alt="Formaggi della Svizzera" />
      <img src="/img/emmentaler.png" alt="Emmentaler" />
      <img src="/img/ulysse-nardin.png" alt="Ulysse Nardin" />
      <img src="/img/miluna.png" alt="Miluna" />
      <img src="/img/vorwerk-folletto.png" alt="Vorwerk Folletto" />
      <img src="/img/kioene.png" alt="Kioene" />
      <img src="/img/comix.png" alt="Comix" />
    </div>
  </section>
</template>

<script>
import { app } from '@/utils/store';
import Clients from './clients';
import nodata from './data';

let clients;

const data = nodata[app.language];

export default {
  data() {
    return {
      data,
    };
  },
  mounted() {
    clients = new Clients();
    clients.init();
  },
  destroyed() {
    clients.destroy();
  },
};
</script>
